import axios from './financeiroApi';

const vendaApi = () => {
  const getPath = () => {
    return `/api/v1/backend/venda`;
  };

  const getParams = (params) => {
    let newParams;
    if (params?.filtroAvancado) {
      if (params.filtroAvancado.identificador) {
        newParams = {
          ...params,
          ...params.filtroAvancado,
          identificador: parseInt(params.filtroAvancado.identificador),
        };
      } else {
        newParams = { ...params, ...params.filtroAvancado };
      }

      delete newParams.filtroAvancado;
    } else {
      newParams = params;
    }

    newParams = {
      ...newParams,
      data: newParams?.data?.format('YYYY-MM-DD'),
    };

    return newParams;
  };

  return {
    buscarTodos: (search) => {
      const url = `${getPath()}`;
      return axios.get(url, { params: getParams(search) });
    },
    buscar: (vendaId) => {
      const url = `${getPath()}/${vendaId}`;
      return axios.get(url);
    },
    criar: (venda, permitirDuplicada = false) => {
      const url = `${getPath()}?permitirDuplicada=${permitirDuplicada}`;
      return axios.post(url, venda);
    },
    atualizar: (venda) => {
      const url = `${getPath()}/${venda.id}`;
      return axios.put(url, venda);
    },
    excluir: (params) => {
      const url = `${getPath()}`;
      return axios.delete(url, {
        data: params,
      });
    },
    getHistorico: (id) => {
      const url = `${getPath()}/historico-situacao/${id}`;
      return axios.get(url);
    },
    aprovarVenda: (id) => {
      const url = `${getPath()}/aprovar-venda/${id}`;
      return axios.post(url);
    },
    enviarOrcamento: (mailRequest) => {
      const url = `${getPath()}/enviar-orcamento/`;
      return axios.post(url, mailRequest);
    },
    getTemplateMailOrcamento: (vendaId) => {
      const url = `${getPath()}/buscar-template-orcamento/${vendaId}`;
      return axios.get(url);
    },
    getVendedorUsuario: () => {
      const url = `${getPath()}/vendedor-usuario`;
      return axios.get(url);
    },
    calcularTotais: (venda) => {
      const url = `${getPath()}/calcular-totais`;
      return axios.post(url, venda);
    },
    buscarContratosVenda: (venda) => {
      const url = `${getPath()}/buscar-contratos`;
      return axios.post(url, venda);
    },
    buscarContratoContaReceberVinculado: (contratoContaReceberId) => {
      const url = `${getPath()}/buscar-contrato-conta-receber/${contratoContaReceberId}`;
      return axios.get(url);
    },
  };
};

export { vendaApi };
